import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { openDiagnostic } from './diagnostic-overlay.js';

/**
 * Diagnostic mode PIN giriş modalı.
 *
 * Beklenen PIN: localStorage 'fp.diagnostic.pin' (eşleme yanıtından yazılır — pair.ts).
 * PIN TANIMLI DEĞİLSE: eski sabit '0000' backdoor'u KALDIRILDI (K4). Bu durumda diagnostic
 * yalnız SALT-GÖRÜNTÜLEME açılır; yıkıcı işlemler (eşleme sıfırla / cache temizle) gizlenir.
 * Böylece TV'ye fiziksel erişimi olan biri ekranı yayından düşüremez.
 */
@customElement('fp-pin-modal')
export class FpPinModal extends LitElement {
    @state() private entered = '';
    @state() private error = '';

    private get expectedPin(): string | null {
        return localStorage.getItem('fp.diagnostic.pin');
    }

    static styles = css`
        :host {
            position: fixed;
            inset: 0;
            background: rgba(0, 0, 0, 0.85);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 100000;
            cursor: auto;
        }
        .modal {
            background: #1a1a1a;
            padding: 2rem;
            border-radius: 12px;
            min-width: 320px;
            color: #fff;
            font-family: 'Inter', system-ui, sans-serif;
        }
        h2 { margin: 0 0 0.5rem; }
        input {
            width: 100%;
            padding: 0.75rem;
            font-size: 1.5rem;
            text-align: center;
            letter-spacing: 0.5em;
            background: #000;
            color: #fff;
            border: 2px solid #333;
            border-radius: 8px;
            margin: 1rem 0;
            box-sizing: border-box;
        }
        .error { color: #dc2626; min-height: 1.2em; font-size: 0.9rem; }
        button {
            width: 100%;
            padding: 0.75rem;
            font-size: 1rem;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            font-weight: 600;
        }
        .ok { background: #f59e0b; color: #000; }
        .cancel { background: #333; color: #fff; margin-top: 0.5rem; }
    `;

    private submit(): void {
        const pin = this.expectedPin;
        if (pin === null) {
            // PIN tanımlı değil → salt-görüntüleme (yıkıcı işlemler kapalı).
            this.remove();
            openDiagnostic(true);
            return;
        }
        if (this.entered === pin) {
            this.remove();
            openDiagnostic(false);
        } else {
            this.error = 'Yanlış PIN';
            this.entered = '';
        }
    }

    render() {
        const noPin = this.expectedPin === null;
        return html`
            <div class="modal">
                <h2>Tanı Ekranı</h2>
                ${noPin
                    ? html`<p>Bu cihaza PIN tanımlı değil. Tanı ekranı yalnızca görüntüleme
                            modunda açılır (kurtarma işlemleri kapalı).</p>`
                    : html`
                          <p>Tanı ekranını açmak için PIN giriniz.</p>
                          <input
                              type="password"
                              inputmode="numeric"
                              maxlength="6"
                              .value=${this.entered}
                              @input=${(e: Event) => {
                                  this.entered = (e.target as HTMLInputElement).value;
                              }}
                              @keydown=${(e: KeyboardEvent) => {
                                  if (e.key === 'Enter') this.submit();
                              }}
                          >
                          <div class="error">${this.error}</div>
                      `}
                <button class="ok" @click=${() => this.submit()}>${noPin ? 'Görüntüle' : 'Aç'}</button>
                <button class="cancel" @click=${() => this.remove()}>İptal</button>
            </div>
        `;
    }
}

export function openPinModal(): void {
    if (document.querySelector('fp-pin-modal')) return;
    document.body.appendChild(document.createElement('fp-pin-modal'));
}
